import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

const PrivacyPolicyPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <div className="max-w-3xl mx-auto px-5 md:px-10 py-24 md:py-32">
        <a href="/" data-testid="privacy-back" className="inline-flex items-center gap-2 text-electric hover:text-electric-hover text-sm font-medium mb-10 font-body">
          <ArrowLeft size={16} />Volver al inicio
        </a>
        <h1 className="text-3xl md:text-4xl font-black text-navy font-heading mb-8">Pol&iacute;tica de Privacidad</h1>
        <p className="text-slate-400 text-sm mb-10 font-body">&Uacute;ltima actualizaci&oacute;n: Enero 2026</p>

        <div className="prose-custom space-y-8 text-slate-600 text-sm leading-relaxed font-body">
          <section>
            <h2 className="text-xl font-bold text-navy font-heading mb-3">1. Responsable del tratamiento</h2>
            <p>OKontainers es responsable del tratamiento de los datos personales recogidos a trav&eacute;s de este sitio web.</p>
            <p className="mt-2">Email: <a href="mailto:info@okontainers.com" className="text-electric hover:underline">info@okontainers.com</a><br/>Tel&eacute;fono: +34 672 808 030</p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-navy font-heading mb-3">2. Datos que recogemos</h2>
            <p>Recogemos los siguientes datos personales &uacute;nicamente cuando t&uacute; nos los proporcionas voluntariamente a trav&eacute;s del formulario de auditor&iacute;a gratuita:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Nombre</li>
              <li>Nombre de la empresa</li>
              <li>Direcci&oacute;n de correo electr&oacute;nico</li>
            </ul>
          </section>
          <section>
            <h2 className="text-xl font-bold text-navy font-heading mb-3">3. Finalidad del tratamiento</h2>
            <p>Los datos proporcionados se utilizan exclusivamente para:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Responder a tu solicitud de auditor&iacute;a gratuita</li>
              <li>Ponernos en contacto contigo para ofrecerte informaci&oacute;n sobre nuestros servicios</li>
              <li>Gestionar la relaci&oacute;n comercial</li>
            </ul>
          </section>
          <section>
            <h2 className="text-xl font-bold text-navy font-heading mb-3">4. Base legal</h2>
            <p>El tratamiento de tus datos se basa en el consentimiento que nos proporcionas al enviar el formulario de contacto, conforme al Reglamento General de Protecci&oacute;n de Datos (RGPD) y la Ley Org&aacute;nica de Protecci&oacute;n de Datos (LOPDGDD).</p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-navy font-heading mb-3">5. Conservaci&oacute;n de datos</h2>
            <p>Tus datos personales se conservar&aacute;n mientras sea necesario para la finalidad para la que fueron recogidos o mientras exista una relaci&oacute;n comercial. Puedes solicitar su eliminaci&oacute;n en cualquier momento.</p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-navy font-heading mb-3">6. Tus derechos</h2>
            <p>Tienes derecho a:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Acceder a tus datos personales</li>
              <li>Rectificar datos inexactos</li>
              <li>Solicitar la supresi&oacute;n de tus datos</li>
              <li>Oponerte al tratamiento</li>
              <li>Solicitar la portabilidad de tus datos</li>
              <li>Limitar el tratamiento</li>
            </ul>
            <p className="mt-2">Para ejercer estos derechos, cont&aacute;ctanos en <a href="mailto:info@okontainers.com" className="text-electric hover:underline">info@okontainers.com</a>.</p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-navy font-heading mb-3">7. Seguridad</h2>
            <p>Implementamos medidas t&eacute;cnicas y organizativas adecuadas para proteger tus datos personales contra el acceso no autorizado, la alteraci&oacute;n, la divulgaci&oacute;n o la destrucci&oacute;n.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
